import { Injectable } from '@angular/core';
import { CtBatch, CtPage } from '../model/ct-batch-model';
import { Observable, ReplaySubject } from 'rxjs';
import { associateBy } from '@ps-gui/shared-utils';

@Injectable({
  providedIn: 'root',
})
export class SharedCtBatchStoreService {
  private readonly _ctBatch = new ReplaySubject<CtBatch>(1);

  private pagesById: Record<string, CtPage> = {};

  set ctBatch(ctBatch: CtBatch) {
    this._ctBatch.next(ctBatch);
    this.pagesById = associateBy(
      ctBatch.documents.flatMap((document) => document.pages),
      (page) => page.id,
    );
  }

  get ctBatch(): Observable<CtBatch> {
    return this._ctBatch.asObservable();
  }

  existsPageInBatch(id: string): boolean {
    return id in this.pagesById;
  }

  getPageById(id: string): CtPage {
    return this.pagesById[id];
  }
}
